import type { Theme, ThemeProviderProps as MuiThemeProviderProps } from '@mui/material/styles';
import type {} from './extend-theme-types';
import type { ThemeOptions } from './types';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles';

import { enUS, heIL } from '@mui/material/locale';

import { Rtl } from './rtl';
import { createTheme } from './create-theme';

// ----------------------------------------------------------------------

export type SupportedLanguage = 'en' | 'he';

export type ThemeProviderProps = Partial<MuiThemeProviderProps<Theme>> & {
  themeOverrides?: ThemeOptions;
  language?: SupportedLanguage;
};

export function ThemeProvider({
  themeOverrides,
  children,
  language = 'en',
  // Force light mode by default and isolate storage key to avoid external overrides
  defaultMode = 'light',
  modeStorageKey = 'treedis-minimals-mode',
  ...other
}: ThemeProviderProps) {
  const isRtl = language === 'he';

  const theme = createTheme({
    // Provide minimal locale components; extend here if more languages are needed
    localeComponents: isRtl ? heIL : enUS,
    themeOverrides,
  });

  return (
    <ThemeVarsProvider
      disableTransitionOnChange
      theme={theme}
      defaultMode={defaultMode}
      modeStorageKey={modeStorageKey}
      {...other}
    >
      <CssBaseline />
      <Rtl direction={isRtl ? 'rtl' : 'ltr'}>{children}</Rtl>
    </ThemeVarsProvider>
  );
}
